const STORAGE_KEY = "yts:affiliate-attribution:v1";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export function readAffiliateAttribution() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "null");
    if (!saved || !saved.referral_code || Date.now() - Number(saved.saved_at || 0) > MAX_AGE_MS) return null;
    return saved;
  } catch {
    return null;
  }
}

export function captureAffiliateAttribution(search, pathname) {
  const params = new URLSearchParams(search || "");
  const referral = (params.get("ref") || params.get("referral") || "").trim().toUpperCase();
  const promo = (params.get("promo") || params.get("code") || "").trim().toUpperCase();
  if (!referral && !promo) return readAffiliateAttribution();
  const previous = readAffiliateAttribution();
  const attribution = {
    referral_code: referral || previous?.referral_code || promo,
    promo_code: promo || previous?.promo_code || "",
    saved_at: Date.now(),
    first_path: pathname || "/",
  };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch {
    // Continue even when storage is disabled.
  }
  return attribution;
}
